import { render } from "./UserDashboard.vue?vue&type=template&id=b4b7eca8&scoped=true"
import script from "./UserDashboard.vue?vue&type=script&lang=js"
export * from "./UserDashboard.vue?vue&type=script&lang=js"

import "./UserDashboard.vue?vue&type=style&index=0&id=b4b7eca8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b7eca8"]])

export default __exports__